const SET_DOSSIERS = "SET_DOSSIERS";
const UPDATE_DOSSIER_STATUT = "UPDATE_DOSSIER_STATUT";
const UPDATE_CONFIRMATION = "UPDATE_CONFIRMATION";
const SET_FILTERS = "SET_FILTERS";
const SET_CURRENT_DOSSIER = "SET_CURRENT_DOSSIER";
const UPDATE_FORM_DATA = "UPDATE_FORM_DATA";
const SET_CURRENT_RUBRIQUE = "SET_CURRENT_RUBRIQUE";
const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
const SET_PAGINATION = "SET_PAGINATION";
const SET_DOSSIER_COMPLET = "SET_DOSSIER_COMPLET";
const SET_DOSSIER_LOADING = "SET_DOSSIER_LOADING";
const API_PENDING_INC = "API_PENDING_INC";
const API_PENDING_DEC = "API_PENDING_DEC";

export {
  SET_DOSSIERS,
  UPDATE_DOSSIER_STATUT,
  UPDATE_CONFIRMATION,
  SET_FILTERS,
  SET_CURRENT_DOSSIER,
  UPDATE_FORM_DATA,
  SET_CURRENT_RUBRIQUE,
  SET_CURRENT_PAGE,
  SET_PAGINATION,
  SET_DOSSIER_COMPLET,
  SET_DOSSIER_LOADING,
  API_PENDING_INC,
  API_PENDING_DEC,
};